import script from "./NavLinks.vue?vue&type=script&setup=true&lang=js"
export * from "./NavLinks.vue?vue&type=script&setup=true&lang=js"

import "./NavLinks.vue?vue&type=style&index=0&id=0a587f99&lang=scss"

const __exports__ = script;

export default __exports__